<template lang='pug'>
.title-container
  b.filter-name(v-text='contentTypeName.toUpperCase()')
  h1.title(v-text='title')
  p.dim(v-text='publishedSince')
</template>
<script>
import { dateUtil } from '../../../../mixins/dateUtil'
export default {
  mixins: [dateUtil],
  props: {
    title: {
      type: String,
      default: '',
      required: true
    },
    contentTypeName: {
      type: String,
      default: '',
      required: true
    },
    publishedAt: {
      type: Date,
      default: new Date(),
      required: true
    }
  }
}
</script>
<style lang='scss' scoped>
.title-container {
  margin-bottom: 10px;

  @media(min-width: 768px) {
    padding: 0;
    margin-bottom: 16px;
  }
}

.title {
  width: 100%;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.filter-name {
  width: 100%;

  display: block;
  font-size: 13px;
  font-weight: bold;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #C9362F;
}

.dim {
  margin-top: 4px;
  color: #999999;
  font-size: 13px;
  line-height: 16px;
}
</style>
